import React, { useEffect, useContext } from 'react';
import Layout from 'components/Layout';
import Salutation from 'components/Salutation';
import AccountTabs from 'components/AccountTabs';
import FormMyAccount from 'components/FormMyAccount';
import UserService from 'services/User/service';
import { AuthContext } from '../../auth/AuthContext';
import { types } from '../../types/types';
import { main_links } from 'config';

const MyAccount = () => {

    const { sessionData, sessionDispatch } = useContext(AuthContext);
    useEffect(() => {
        UserService.info().then( (info) => {
            if(!info) return;

            delete info.bonus;
            let names = (!!info.names && info.names!=='null') ? info.names : null;
            let lastNames = (!!info.lastNames&& info.lastNames!=='null') ? info.lastNames : null;

            sessionDispatch({
                type: types.change,
                payload: {
                    fullname: (names && lastNames) ? `${names} ${lastNames}`: null, 
                    firstname: names, 
                    lastname: lastNames,
                    docType: info.identityDocument.codTipoDocumento!=-1? info.identityDocument.codTipoDocumento: 9,
                    docNumber: info.identityDocument.numeroDocumento,
                    phone: info.telef,
                    email: info.email
                }
            })
        });
    }, []);

    return (
        <div className="mi-cuenta cupones is-logged">
            <Layout showBanner={false}>
                <Salutation sessionData={sessionData}/>
                <section className="my-account">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-3 mt-4 left-menu">
                                <AccountTabs currentPath={main_links.my_account}/>
                            </div>
                            <div className="col-12 col-lg-9 mt-4">
                                <div className="border">
                                    <FormMyAccount accountData={sessionData}/>
                                </div>
                            </div>
                            <div className="col-12">
                                <br /><br /><br />
                                <br /><br /><br />
                                <br /><br /><br />
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    )
};

export default MyAccount;